import React from "react";
import PropTypes from "prop-types";
import i18n from "i18n-react";
import { FaDollarSign, FaShoppingCart, FaRoute, FaUsers } from "react-icons/fa";
import KpiCard from "./KpiCard";
import { formatCurrency, formatNumber, formatPercent } from "./ordersDashboardFormatters";

const SummaryKpis = ({ dashboard }) => (
    <>
        <div className="orders-section-label">{i18n.translate("orders_dashboard_financial_summary")}</div>
        <div className="orders-kpi-grid">
            <KpiCard
                icon={<FaDollarSign />}
                label={i18n.translate("orders_dashboard_total_sales")}
                value={formatCurrency(dashboard?.totalSales)}
                comparison={dashboard?.totalSalesComparison}
            />
            <KpiCard
                icon={<FaShoppingCart />}
                label={i18n.translate("orders_dashboard_total_orders")}
                value={formatNumber(dashboard?.totalOrders)}
                comparison={dashboard?.totalOrdersComparison}
            />
            <KpiCard
                icon={<FaRoute />}
                label={i18n.translate("orders_dashboard_visit_order_ratio")}
                value={formatPercent(dashboard?.visitOrderRatio)}
                comparison={dashboard?.visitOrderRatioComparison}
            />
            <KpiCard
                icon={<FaUsers />}
                label={i18n.translate("orders_dashboard_unique_customers")}
                value={formatNumber(dashboard?.uniqueCustomers)}
            />
        </div>
    </>
);

SummaryKpis.propTypes = {
    dashboard: PropTypes.shape({
        totalSales: PropTypes.number,
        totalSalesComparison: PropTypes.object,
        totalOrders: PropTypes.number,
        totalOrdersComparison: PropTypes.object,
        visitOrderRatio: PropTypes.number,
        visitOrderRatioComparison: PropTypes.object,
        uniqueCustomers: PropTypes.number
    }).isRequired
};

export default SummaryKpis;
